import * as React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Drawer from "@mui/material/Drawer";
import { Alert, Button, Chip, Divider, Grid, Tooltip } from "@mui/material";
import close from "../../assets/icons/close.png";
import { DeleteStepfile, getKamProfilePicApi } from "../Services/OrgRepo";
import {
    accountManager,
    generatProfilePicUrl,
    generatStepFileUrl
} from "../../Utils/Constant";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DeleteIcon from "@mui/icons-material/Delete";
import fileImg from "../../assets/images/file.png";
import StepFileView from "../autosdk/StepFileView";

interface StepFileProps {
    open: boolean;
    onClose: () => void;
    setDeleteStepFile: any;
    selectedRowData: any;
    finalApprovalReportDetails: any;
}

export const StepFile: React.FC<StepFileProps> = ({
    open,
    onClose,
    setDeleteStepFile,
    selectedRowData,
    finalApprovalReportDetails
}) => {
    const [profileImage, setProfileImage] = React.useState("");
    const [selectedCheckBoxRows, setSelectedCheckBoxRows] = React.useState([]);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [deleteLoading, setDeleteLoading] = React.useState(false);

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const handleSelectionChange = (selectionModel) => {
        setSelectedCheckBoxRows(selectionModel);
    };
    const getProfilePic = async () => {
        try {
            const data = await getKamProfilePicApi(selectedRowData?.KAMId);
            if (data?.status) {
                const img = generatProfilePicUrl(
                    selectedRowData?.KAMId,
                    data?.data,
                    "Profile_Picture"
                );
                setProfileImage(img);
            } else {
                setProfileImage("");
            }
        } catch (err) {
            setProfileImage("");
            console.log("Error while fetching getCompanyData");
        }
    };

    React.useEffect(() => {
        if (selectedRowData?.rfqName) {
            setProfileImage("");
        }
        if (selectedRowData?.KAMId) {
            getProfilePic();
        }
        setSelectedCheckBoxRows([]);
    }, [open]);

    const rows = (
        typeof selectedRowData?.stepUploadedFile === "string"
            ? selectedRowData?.stepUploadedFile.split(",")
            : Array.isArray(selectedRowData?.stepUploadedFile)
              ? selectedRowData?.stepUploadedFile
              : []
    ).map((cert: string, index: number) => {
        // Handle URN extraction - adjust based on your actual data structure
        let stepFileUrn = null;
        if (Array.isArray(selectedRowData?.stepFileUrn)) {
            stepFileUrn = selectedRowData?.stepFileUrn[index];
        } else if (selectedRowData?.stepFileUrn) {
            // If it's a single URN string, use it for the first file
            stepFileUrn = index === 0 ? selectedRowData?.stepFileUrn : null;
        }
        return {
            id: index + 1,
            stepFile: cert.trim(),
            stepFileUrn: stepFileUrn
        };
    });

    // const rows = (
    //   Array.isArray(selectedRowData?.stepUploadedFile)
    //     ? selectedRowData?.stepUploadedFile
    //     : selectedRowData?.stepUploadedFile
    //       ? [selectedRowData?.stepUploadedFile]
    //       : []
    // )
    //   .map((file: string, idx: number) => {
    //     let urn: string | null = null;

    //     if (Array.isArray(selectedRowData?.stepFileUrn)) {
    //       urn = selectedRowData?.stepFileUrn[idx] || null;
    //     } else if (typeof selectedRowData?.stepFileUrn === "string") {
    //       urn = idx === 0 ? selectedRowData?.stepFileUrn : null;
    //     }

    //     return {
    //       id: idx + 1,
    //       stepFile: file.trim(),
    //       stepFileUrn: urn,
    //     };
    //   })
    //   .filter(
    //     (row) => row.stepFile && row.stepFileUrn && row.stepFileUrn !== "-"
    //   );

    // Define columns for DataGrid
    const columns: GridColDef[] = [
        {
            field: "3dfile",
            headerName: "3D File",
            flex: 1,
            disableColumnMenu: true,
            renderCell: (params) => {
                const hasUrn =
                    params.row.stepFileUrn && params.row.stepFileUrn !== "-";
                return (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%"
                        }}
                    >
                        {/* Left side: file icon + name */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                flex: 1
                            }}
                        >
                            <img src={fileImg} width="20px" alt="file" />
                            <Typography
                                variant="body2"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {/* {params.row.stepFile} */}
                                {"3D File"}
                            </Typography>
                        </Box>
                        {/* Right side: View button - Only show if URN exists */}
                        {hasUrn ? (
                            <StepFileView
                                urn={params.row.stepFileUrn}
                                fileName={params.row.stepFile}
                            />
                        ) : (
                            <Typography
                                variant="caption"
                                color="text.secondary"
                            >
                                No 3D view
                            </Typography>
                        )}
                    </Box>
                );
            }
        }
    ];

    const handleDownloadDrawing = () => {
        if (rows[0]?.stepFile) {
            const generateUrl = generatStepFileUrl(
                selectedRowData?.partID,
                rows[0]?.stepFile
            );
            const link = document.createElement("a");
            link.href = generateUrl;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleDelete = async () => {
        setDeleteLoading(true);

        let payload = {
            ID: selectedRowData?.partID,
            uploadField: "Upload_Step_File"
        };
        try {
            const res = await DeleteStepfile(payload);
            if (res?.status) {
                onClose();
                setDeleteStepFile(true);
            } else {
                alert("Failed to delete file(s)");
            }
        } catch (err) {
            console.error("Error deleting files", err);
            alert("An error occurred while deleting files");
        } finally {
            setDeleteLoading(false);
            setOpenDialog(false);
        }
        handleClose();
    };
    return (
        <>
            <Drawer anchor="right" open={open} onClose={onClose}>
                <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                    {/* Header Section */}
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h6" fontWeight="bold">
                            3D Files
                        </Typography>
                        <Box>
                            <IconButton
                                onClick={onClose}
                                sx={{ padding: "10px" }}
                            >
                                <img src={close} width={"14px"} alt="Close" />
                            </IconButton>
                        </Box>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    {/* Organisation Details */}
                    <Box display="flex" alignItems="center" gap={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Company RFQ ID
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography variant="body2">
                                    {selectedRowData?.rfqId}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} md={5}>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                >
                                    Created By
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={7}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    {profileImage && (
                                        <img
                                            src={profileImage}
                                            width={24}
                                            height={24}
                                            style={{
                                                marginRight: "5px",
                                                borderRadius: "50%"
                                            }}
                                            alt="KAM"
                                        />
                                    )}

                                    {selectedRowData?.keyAccountManager || "-"}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    {/* Company Listing */}
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between"
                            }}
                            mb={2}
                        >
                            <Typography
                                variant="subtitle1"
                                fontWeight="bold"
                                sx={{ mb: 1 }}
                            >
                                3D Files List
                            </Typography>
                            <div>
                                <Tooltip title="Download">
                                    <Button
                                        variant="outlined"
                                        disabled={
                                            selectedCheckBoxRows?.length === 0
                                        }
                                        onClick={handleDownloadDrawing}
                                        sx={{
                                            minWidth: "35px",
                                            marginRight: "5px",
                                            padding: "5px 8px"
                                        }}
                                    >
                                        <FileDownloadIcon />
                                    </Button>
                                </Tooltip>
                                {accountManager() &&
                                    finalApprovalReportDetails?.status !==
                                        "Approved" &&
                                    finalApprovalReportDetails?.status !==
                                        "Rejected" && (
                                        <Tooltip title="Delete">
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                onClick={handleClickOpen}
                                                disabled={
                                                    selectedCheckBoxRows?.length ===
                                                    0
                                                }
                                                sx={{
                                                    minWidth: "35px",
                                                    padding: "5px 8px"
                                                }}
                                            >
                                                <DeleteIcon />
                                            </Button>
                                        </Tooltip>
                                    )}
                            </div>
                        </Box>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            checkboxSelection
                            onRowSelectionModelChange={handleSelectionChange}
                            hideFooter
                            autoHeight
                        />
                    </>
                </Box>
            </Drawer>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete the uploaded Step file?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error" size="small">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDelete}
                        autoFocus
                        size="small"
                        disabled={deleteLoading}
                    >
                        {deleteLoading ? "Deleting..." : "Delete"}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
